export const AttributeCard = ({ image, description }: { image: string; description: string }) => {
    return (
        <div style={{ backgroundColor: '#fff', borderRadius: '5px', padding: '10px', minWidth: '170px', marginBottom: '16px', textAlign: 'center' }}>
            <img 
                src={image} 
                alt="attribute logo" 
                style={{ 
                    width: '40px', 
                    height: 'auto', 
                    margin: '0 auto'
                }} 
            />
            <p style={{ fontFamily: "'Manrope', sans-serif", fontSize: '16px', color: '#1F2933', marginTop: '15px' }}>
                {description}
            </p>
        </div>
    );
};